<div *ngIf="form.hasError('missingHighAffinityBinding')" class="form-error-banner">
    <mat-error
        >High affinity required: At least one binding with SubjectKeyIdentifier, SHA1PublicKey, or IssuerAndSerialNumber
        is required when Required Affinity Binding is set to High.</mat-error
    >
</div>

<div *ngIf="form.hasError('missingLowAffinityBinding')" class="form-error-banner">
    <span
        >Low affinity required: At least one binding  is
        required when Required Affinity Binding is set to Low.</span
    >
</div>

<form [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>Field</th>

            <th>Current Value</th>

            <th>Desired Value</th>

            <th>Status</th>
        </tr>

        <tr>
            <td>State</td>

            <td>
                {{ data?.state === 'enabled' ? 'Enabled' : data?.state === 'disabled' ? 'Disabled' : 'Not set' }}
            </td>

            <td>
                <mat-form-field appearance="fill">
                    <mat-label>State</mat-label>
                    <mat-select formControlName="state">
                        <mat-option [value]="'enabled'">Enabled</mat-option>
                        <mat-option [value]="'disabled'">Disabled</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>

            <td>
                <sway-baseline-status [hasError]="errorsString.includes('state')"></sway-baseline-status>
            </td>
        </tr>

        <ng-container *ngIf="form.get('state')?.value === 'enabled'">
            <tr>
                <td>
                    Default authentication strength

                    <mat-icon
                        matTooltip="Note: The default binding will ensure the certificates bind to the selected protection strength setting unless special rules are applied."
                    >
                        info
                    </mat-icon>
                </td>

                <td>
                    {{
                        data?.authenticationModeConfiguration?.x509CertificateAuthenticationDefaultMode ===
                        'x509CertificateSingleFactor'
                            ? 'Single Factor'
                            : data?.authenticationModeConfiguration?.x509CertificateAuthenticationDefaultMode ===
                                'x509CertificateMultiFactor'
                              ? 'Multi Factor'
                              : 'Not set'
                    }}
                </td>

                <td>
                    <div formGroupName="authenticationModeConfiguration">
                        <mat-form-field appearance="fill">
                            <mat-label>Default authentication strength</mat-label>
                            <mat-select formControlName="x509CertificateAuthenticationDefaultMode">
                                <mat-option [value]="'x509CertificateSingleFactor'">Single Factor</mat-option>
                                <mat-option [value]="'x509CertificateMultiFactor'">Multi Factor</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('x509CertificateAuthenticationDefaultMode')"
                    ></sway-baseline-status>
                </td>
            </tr>

            <tr>
                <td>
                    Required Affinity Binding

                    <mat-icon
                        matTooltip="Note: The default binding will ensure the certificates bind to the selected protection strength setting unless special rules are applied."
                    >
                        info
                    </mat-icon>
                </td>

                <td>
                    {{
                        data?.authenticationModeConfiguration?.x509CertificateDefaultRequiredAffinityLevel === 'low'
                            ? 'Low'
                            : data?.authenticationModeConfiguration?.x509CertificateDefaultRequiredAffinityLevel ===
                                'high'
                              ? 'High'
                              : 'Not set'
                    }}
                </td>

                <td>
                    <div formGroupName="authenticationModeConfiguration">
                        <mat-form-field appearance="fill">
                            <mat-label>Required Affinity Binding</mat-label>
                            <mat-select formControlName="x509CertificateDefaultRequiredAffinityLevel">
                                <mat-option value="low">Low</mat-option>
                                <mat-option value="high">High</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('x509CertificateDefaultRequiredAffinityLevel')"
                    ></sway-baseline-status>
                </td>
            </tr>

            <tr *ngIf="form.get('state')?.value === 'enabled'">
                <td>
                    Require CRL Validation

                    <mat-icon
                        matTooltip="This setting requires a CRL check for every certificate authority (CA). If the CRL distribution point is empty or not configured for your CAs, the authentication will fail. You can exempt certificate authorities from the CRL validation requirement."
                    >
                        info
                    </mat-icon>
                </td>

                <td>
                    {{
                        data?.crlValidationConfiguration?.state === 'enabled'
                            ? 'Enabled'
                            : data?.crlValidationConfiguration?.state === 'disabled'
                              ? 'Disabled'
                              : 'Not set'
                    }}
                </td>

                <td>
                    <div formGroupName="crlValidationConfiguration">
                        <mat-form-field appearance="fill">
                            <mat-label>Require CRL Validation</mat-label>
                            <mat-select formControlName="state">
                                <mat-option [value]="'enabled'">Enabled</mat-option>
                                <mat-option [value]="'disabled'">Disabled</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('crlValidationConfiguration')"
                    ></sway-baseline-status>
                </td>
            </tr>

            <tr *ngIf="form.get('state')?.value === 'enabled'">
                <td>
                    Issuer Hints

                    <mat-icon
                        matTooltip="Enable issuer hints to show only the valid certificates in the certificate picker during authentication."
                    >
                        info
                    </mat-icon>
                </td>

                <td>
                    {{
                        data?.issuerHintsConfiguration?.state === 'enabled'
                            ? 'Enabled'
                            : data?.issuerHintsConfiguration?.state === 'disabled'
                              ? 'Disabled'
                              : 'Not set'
                    }}
                </td>

                <td>
                    <div formGroupName="issuerHintsConfiguration">
                        <mat-form-field appearance="fill">
                            <mat-label>Issuer Hints</mat-label>
                            <mat-select formControlName="state">
                                <mat-option [value]="'enabled'">Enabled</mat-option>
                                <mat-option [value]="'disabled'">Disabled</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('issuerHintsConfiguration')"
                    ></sway-baseline-status>
                </td>
            </tr>
        </ng-container>
    </table>

    <!-- Certificate User Bindings accordion - independent, outside main form -->
    <div class="mt-4">
        <mat-accordion *ngIf="form.get('state')?.value === 'enabled'">
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <div class="items-center w-full flex justify-between">
                        <mat-panel-title class="font-bold"> Certificate User Bindings </mat-panel-title>
                        <div>
                            <sway-baseline-status
                                [hasError]="errorsString.includes('certificateUserBindings')"
                            ></sway-baseline-status>
                        </div>
                    </div>
                </mat-expansion-panel-header>

                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>Field</th>
                                <th>Current Value</th>
                                <th>Desired Value</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    Certificate User Bindings

                                    <mat-icon
                                        class="ml-2"
                                        matTooltip="Define how certificate fields map to user properties for authentication. Priority determines the order in which bindings are evaluated."
                                        >info</mat-icon
                                    >
                                </td>

                                <td>
                                    <div *ngIf="data?.certificateUserBindings?.length > 0">
                                        <table class="child-table mat-elevation-z2">
                                            <thead>
                                                <tr>
                                                    <th class="child-cell">Certificate Field</th>
                                                    <th class="child-cell">User Property</th>
                                                    <th class="child-cell">Trust Affinity</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let b of data?.certificateUserBindings">
                                                    <td class="child-cell">{{ b.x509CertificateField }}</td>
                                                    <td class="child-cell">{{ b.userProperty }}</td>
                                                    <td class="child-cell">{{ b.trustAffinityLevel ?? 'N/A' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div *ngIf="!data?.certificateUserBindings?.length">Not set</div>
                                </td>

                                <td>
                                    <table
                                        class="child-table mat-elevation-z2"
                                        *ngIf="bindingsFormArray.controls.length > 0"
                                    >
                                        <thead>
                                            <tr>
                                                <th class="child-cell">Certificate Field</th>
                                                <th class="child-cell">User Property</th>
                                                <th class="child-cell">Trust Affinity</th>
                                                <th class="child-cell" *ngIf="!readOnly">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let bindingCtrl of bindingsFormArray.controls; let i = index">
                                                <td class="child-cell">
                                                    {{ bindingCtrl.get('x509CertificateField')?.value }}
                                                </td>
                                                <td class="child-cell">{{ bindingCtrl.get('userProperty')?.value }}</td>
                                                <td class="child-cell">
                                                    {{ bindingCtrl.get('trustAffinityLevel')?.value }}
                                                </td>
                                                <td class="child-cell" *ngIf="!readOnly">
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        (click)="openEditBindingDialog(i)"
                                                        matTooltip="Edit binding"
                                                    >
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                    <button
                                                        mat-icon-button
                                                        type="button"
                                                        color="warn"
                                                        (click)="removeBinding(i)"
                                                        matTooltip="Remove binding"
                                                    >
                                                        <mat-icon>delete</mat-icon>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div *ngIf="bindingsFormArray.controls.length === 0" class="mt-2">
                                        No bindings configured.
                                    </div>
                                    <div class="mt-3" *ngIf="!readOnly">
                                        <button
                                            mat-button
                                            type="button"
                                            color="primary"
                                            (click)="openAddBindingDialog()"

                                            class="mt-2"
                                        >
                                            <mat-icon>add</mat-icon> Add Binding
                                        </button>
                                    </div>
                                    <div
                                        *ngIf="form.hasError('missingHighAffinityBinding')"
                                        class="mat-error-text mt-2"
                                    >
                                        <mat-icon color="warn">error_outline</mat-icon>
                                        <span
                                            >High affinity required: At least one binding with SubjectKeyIdentifier,
                                            SHA1PublicKey, or IssuerAndSerialNumber is required when Required Affinity
                                            Binding is set to High.</span
                                        >
                                    </div>
                                    <div *ngIf="form.hasError('missingLowAffinityBinding')" class="mat-error-text mt-2">
                                        <mat-icon color="warn">error_outline</mat-icon>
                                        <span
                                            >Low affinity required: At least one binding with RFC822Name, PrincipalName,
                                            IssuerAndSubject, or Subject is required when Required Affinity Binding is
                                            set to Low.</span
                                        >
                                    </div>
                                </td>

                                <td>
                                    <sway-baseline-status
                                        [hasError]="
                                            errorsString.includes('certificateUserBindings') ||
                                            form.hasError('missingHighAffinityBinding') ||
                                            form.hasError('missingLowAffinityBinding')
                                        "
                                    ></sway-baseline-status>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </mat-expansion-panel>
        </mat-accordion>
    </div>

    <div class="mt-4" *ngIf="form.get('state')?.value === 'enabled'">
        <app-authentication-method-policy-targets
            [readOnly]="readOnly"
            [showIsUsableForSignIn]="false"
            [groups]="groups$ | async"
            [tenantId]="tenant_id"
            [form]="form"
            [policy]="data"
            [item]="baselineTemplateItem"
            [errorsString]="errorsString"
        ></app-authentication-method-policy-targets>
    </div>
</form>
